import { api as com, apiFuns } from 'sw-hic';
let {get, post, put, del} = apiFuns

const api = {
  /** **********结算标准接口****************** **/
  NursingItem: apiFuns.genStandard("nursingItem", "/api/ip"),
  FeeStandard: apiFuns.genStandard("feeStandard", "/api/md"),
};

export default api;
